import { FormHelperText } from '@mui/material'
import { FieldError, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { FileUploader, Resource } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { CreateEventValue, FileUploadInfo } from '../EventCreateForm'

type ThumbnailUploadCellProps = {
  watch: UseFormWatch<CreateEventValue>
  fileUploadInfo: FileUploadInfo
  setValue: UseFormSetValue<CreateEventValue>
  error?: FieldError
}

export const ThumbnailUploadCell: Cell<ThumbnailUploadCellProps> = ({
  watch,
  setValue,
  fileUploadInfo,
  error,
}) => {
  const { t } = useTranslation('consoleEventCreate')
  return (
    <CellFrame sx={{ pb: 8 }}>
      <FileUploader
        sx={{ p: 0 }}
        shape="collection"
        resource={watch('thumbnailResource') as Resource | undefined}
        t={t}
        requireLabel={{ display: true }}
        fileUploadInfo={{
          type: 'image',
          async onDrop() {
            const resource = await fileUploadInfo.onDrop()
            if (!resource) {
              return
            }
            setValue('thumbnailPath', resource.imageUploadPath as never, {
              shouldValidate: true,
            })
            setValue(
              'thumbnailResource',
              { ...resource },
              { shouldValidate: true }
            )
            return resource
          },
          progress: fileUploadInfo.progress || 0,
          description: t('thumbnailUploaderDescription'),
          onClose() {
            setValue('thumbnailResource', null, {
              shouldDirty: true,
              shouldValidate: true,
            })
            setValue('thumbnailPath', '', {
              shouldDirty: true,
              shouldValidate: true,
            })
          },
        }}
        content={{ title: t('thumbnailUploaderTitle') }}
      />
      {!!error && <FormHelperText error>{error.message}</FormHelperText>}
    </CellFrame>
  )
}
